import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "paymentMethodSelect", "transferReceiptSection",
    "transferReceiptInput", "transferReceiptDisplay",
    "submitBtn", "errorAlert"
  ]

  static values = {
    saleId: Number,
    csrfToken: String
  }

  paymentMethodChanged() {
    const method = this.paymentMethodSelectTarget.value
    if (this.hasTransferReceiptSectionTarget) {
      this.transferReceiptSectionTarget.style.display = method === 'wire' ? 'block' : 'none'
    }
  }

  updateReceiptFileName(event) {
    const fileInput = event.target
    if (this.hasTransferReceiptDisplayTarget) {
      if (fileInput.files && fileInput.files.length > 0) {
        this.transferReceiptDisplayTarget.value = fileInput.files[0].name
      } else {
        this.transferReceiptDisplayTarget.value = ''
      }
    }
  }

  async submitPayment() {
    this.hideError()

    const paymentMethod = this.paymentMethodSelectTarget.value
    if (!paymentMethod) {
      this.showError('Debe seleccionar un método de pago.')
      return
    }

    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Registrando pago...'

    try {
      const formData = new FormData()
      formData.append('payment_method', paymentMethod)

      if (paymentMethod === 'wire' && this.hasTransferReceiptInputTarget) {
        const fileInput = this.transferReceiptInputTarget
        if (fileInput.files && fileInput.files.length > 0) {
          formData.append('transfer_receipt', fileInput.files[0])
        }
      }

      const response = await fetch(`/sales/${this.saleIdValue}/record_payment`, {
        method: 'PATCH',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.csrfTokenValue
        },
        body: formData
      })

      const data = await response.json()

      if (data.success) {
        window.location.reload()
      } else {
        this.showError(data.error || 'Error al registrar el pago')
        this.submitBtnTarget.disabled = false
        this.submitBtnTarget.innerHTML = '<i class="fas fa-credit-card mr-1"></i> Registrar Pago'
      }
    } catch (error) {
      this.showError(`Error: ${error.message}`)
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.innerHTML = '<i class="fas fa-credit-card mr-1"></i> Registrar Pago'
    }
  }

  showError(message) {
    if (this.hasErrorAlertTarget) {
      this.errorAlertTarget.textContent = message
      this.errorAlertTarget.style.display = 'block'
    }
  }

  hideError() {
    if (this.hasErrorAlertTarget) {
      this.errorAlertTarget.style.display = 'none'
    }
  }
}
